//\nで改行した要素を返すコンポーネント
import { Fragment } from "react"

interface IFProps {
    val: string
}

export function MultiLine(props:IFProps):JSX.Element{
    let tmpLine = props.val.split("\n");
    return (
        <>
            {tmpLine.map(function(line, idx){
                return (
                    <Fragment key={idx}>{line}<br/></Fragment>
                )
            })}
        </>
    )
}